import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { AppConfig } from "@config/config";

import { resources } from "./resources";
import { extractNamespaces } from "./utils/extractNamespaces";

export type SupportedLangs = (typeof supportedLangs)[number];

export const supportedLangs = ["en", "pl"] as const;
export const defaultLang = supportedLangs[0];

export const LANG_STORAGE_KEY = "tix-lng";
export const APP_LANG = i18n.language;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLang,
    supportedLngs: supportedLangs,
    ns: extractNamespaces(resources),
    resources,
    interpolation: {
      escapeValue: true
    },
    react: {
      useSuspense: false,
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"]
    },
    returnNull: false,
    saveMissing: true,
    parseMissingKeyHandler: (key) => `Translation key missing: ${key}`,
    detection: {
      order: ["localStorage", "cookie", "sessionStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: LANG_STORAGE_KEY,
      lookupCookie: LANG_STORAGE_KEY,
      lookupSessionStorage: LANG_STORAGE_KEY
    },
    debug: AppConfig.i18nDebugMode
  });

export default i18n;
